// All copy + image references for the single-page site.
// Editing this file updates the entire site.

export const BRAND = {
  name: "Sri Bhavani Kalyana Mandira",
  shortName: "Sri Bhavani",
  tagline: "Where Tradition Meets Celebration",
  location: "Basavanagudi · Bengaluru",
  phone: "+91 80 2661 1131",
  phoneRaw: "+918026611131",
  whatsapp: "+91 95918 22207",
  whatsappRaw: "919591822207",
  email: "sribkmblr@gmail.com",
  address:
    "Door No. 94, North Anjaneya Temple Street, Gandhi Bazaar, Basavanagudi, Bengaluru, Karnataka 560004",
  shortAddress: "# 94, N. Anjaneya Temple Street, Basavanagudi",
  mapsLink: "https://maps.app.goo.gl/EMVcxz9ZHxsRQ78FA",
  mapsEmbed:
    "https://maps.google.com/maps?q=Sri%20Bhavani%20Kalyana%20Mandira%20Basavanagudi%20Bangalore&t=&z=17&ie=UTF8&iwloc=&output=embed",
  hours: "Open Daily · 10:00 AM — 7:00 PM",
  // Full brand-kit logo (BRM emblem + sri bhavani kalyana mandira + Wedding | Events | Functions)
  logoUrl:
    "https://customer-assets.emergentagent.com/job_bhavani-mandira/artifacts/r0yzk2uj_BKM%20Brand%20Kit%20%281%29.png",
  // BRM emblem only — used as a compact mark / footer accent
  emblemUrl:
    "https://customer-assets.emergentagent.com/job_bhavani-mandira/artifacts/39u597n9_BKM%20Brand%20Kit%20%283%29.png",
};

// All real venue photographs supplied by the client
export const IMAGES = {
  heroPrimary:
    "https://customer-assets.emergentagent.com/job_bhavani-mandira/artifacts/4wjaold3_WhatsApp%20Image%202026-06-20%20at%2023.24.50%20%281%29.jpeg", // mango-leaf hangings beneath maroon ceiling
  heroSecondary:
    "https://customer-assets.emergentagent.com/job_bhavani-mandira/artifacts/1vdktw2g_WhatsApp%20Image%202026-06-20%20at%2023.24.50%20%282%29.jpeg",
  founderPortrait:
    "https://customer-assets.emergentagent.com/job_bhavani-mandira/artifacts/4enmnq1a_WhatsApp%20Image%202026-06-19%20at%2017.33.15.jpeg", // Sri L. Manae Hanumanth Rao (sepia portrait)
  venueEntrance:
    "https://customer-assets.emergentagent.com/job_bhavani-mandira/artifacts/j4467pl8_WhatsApp%20Image%202026-06-18%20at%2021.07.12.jpeg", // venue entrance with marigold + banana leaves
  exterior:
    "https://customer-assets.emergentagent.com/job_bhavani-mandira/artifacts/afea3wok_WhatsApp%20Image%202026-06-18%20at%2021.07.12.jpeg",
  engagement:
    "https://customer-assets.emergentagent.com/job_bhavani-mandira/artifacts/o9hpv7oh_WhatsApp%20Image%202026-06-14%20at%2016.28.13.jpeg",
  weddingStage:
    "https://customer-assets.emergentagent.com/job_bhavani-mandira/artifacts/xgwscaug_WhatsApp%20Image%202026-06-14%20at%2019.35.20%20%283%29.jpeg",
  puja:
    "https://customer-assets.emergentagent.com/job_bhavani-mandira/artifacts/qpeav8wl_WhatsApp%20Image%202026-06-14%20at%2019.36.25%20%281%29.jpeg",
  carvedMandap:
    "https://customer-assets.emergentagent.com/job_bhavani-mandira/artifacts/1vdktw2g_WhatsApp%20Image%202026-06-20%20at%2023.24.50%20%282%29.jpeg",
  bridalCouple:
    "https://customer-assets.emergentagent.com/job_bhavani-mandira/artifacts/e5ylhpt8_WhatsApp%20Image%202026-06-20%20at%2023.24.50.jpeg",
  marigoldEntrance:
    "https://customer-assets.emergentagent.com/job_bhavani-mandira/artifacts/elwbleu5_WhatsApp%20Image%202026-06-20%20at%2023.23.44.jpeg",
  garlandMacro:
    "https://customer-assets.emergentagent.com/job_bhavani-mandira/artifacts/40rs3xgg_WhatsApp%20Image%202026-06-20%20at%2023.24.50%20%283%29.jpeg",
  marigoldWall:
    "https://customer-assets.emergentagent.com/job_bhavani-mandira/artifacts/ryt52j9f_WhatsApp%20Image%202026-06-20%20at%2023.24.49.jpeg",
};

export const GALLERY = [
  { src: IMAGES.heroPrimary, alt: "Mango-leaf garlands hanging beneath the traditional maroon ceiling" },
  { src: IMAGES.marigoldEntrance, alt: "Marigold and banana-leaf decorated entrance hallway" },
  { src: IMAGES.carvedMandap, alt: "Traditional carved wooden mandap with floral garlands" },
  { src: IMAGES.bridalCouple, alt: "Bride and groom in traditional attire at the venue" },
  { src: IMAGES.weddingStage, alt: "Grand wedding stage with floral arch backdrop" },
  { src: IMAGES.engagement, alt: "Engagement entrance with Ganesha and welcome board" },
  { src: IMAGES.exterior, alt: "Sri Bhavani Kalyana Mandira — exterior with marigold garlands" },
  { src: IMAGES.puja, alt: "Bhajan and puja gathering at the venue" },
  { src: IMAGES.garlandMacro, alt: "Close-up of marigold and lotus garland detail" },
  { src: IMAGES.marigoldWall, alt: "Floral wall — marigolds and tuberose" },
];

export const NAV_LINKS = [
  { label: "Welcome", id: "welcome" },
  { label: "About", id: "about" },
  { label: "Events", id: "events" },
  { label: "Facilities", id: "facilities" },
  { label: "Gallery", id: "gallery" },
  { label: "Contact", id: "contact" },
];

export const WHY_CHOOSE_US = [
  {
    title: "Prime Location",
    body:
      "Situated on E. Anjaneya Temple Street near Gandhi Bazaar, easily accessible from anywhere in South Bangalore.",
  },
  {
    title: "Spacious Event Spaces",
    body:
      "A grand main seating hall paired with a dedicated dining area, comfortably hosting large family gatherings.",
  },
  {
    title: "Affordable Luxury",
    body:
      "A budget-friendly, culturally rich choultry that does not compromise on space, ambiance or hospitality.",
  },
  {
    title: "Flexible Services",
    body:
      "Bring your own decorators and caterers, and customise your special day exactly the way you envisioned it.",
  },
];

export const EVENTS = [
  {
    title: "Weddings & Receptions",
    body:
      "Host an authentic, grand South Indian wedding or an elegant reception. The main hall offers ample seating and an excellent view of every ritual.",
    image: IMAGES.weddingStage,
  },
  {
    title: "Engagements & Pre-Wedding Ceremonies",
    body:
      "Celebrate ring ceremonies, Mehendi, Sangeet, and Haldi in a warm, vibrant setting that adapts to your themes.",
    image: IMAGES.engagement,
  },
  {
    title: "Sacred Thread Ceremonies",
    body:
      "Perform Upanayana and other traditional rituals with utmost comfort — a spacious, auspicious setup for family and priests.",
    image: IMAGES.carvedMandap,
  },
  {
    title: "Baby Showers & Naming Ceremonies",
    body:
      "Welcome the newest member of your family in an intimate, cozy and joyful celebration with your closest people.",
    image: IMAGES.bridalCouple,
  },
  {
    title: "Cultural & Community Gatherings",
    body:
      "Bhajans, cultural performances, spiritual discourses, music concerts and community meetings — a versatile space.",
    image: IMAGES.puja,
  },
];

export const FACILITIES = [
  {
    title: "Grand Reception Hall",
    body:
      "Spacious, well-ventilated main auditorium with an elevated stage — perfect for grand decorations and photography.",
  },
  {
    title: "Dedicated Dining Hall",
    body:
      "Separate dining area for traditional sit-down banana-leaf meals or modern buffet setups, serving large crowds smoothly.",
  },
  {
    title: "Bridal & Groom Rooms",
    body:
      "Complimentary, well-appointed changing rooms with basic amenities for the bride, groom and immediate family.",
  },
  {
    title: "Flexible Vendor Policy",
    body:
      "Complete freedom to choose your own caterers (as per management guidelines) and decorators to match your taste.",
  },
  {
    title: "Functional Kitchen Space",
    body:
      "Large, functional kitchen area provided for your catering team to prepare and serve fresh meals efficiently.",
  },
  {
    title: "Proximity to Transit",
    body:
      "Located near major landmarks, bus stops and metro lines in South Bangalore — convenient access for every guest.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "We hosted my sister's wedding here and the experience was seamless. It is a wonderfully spacious and well-maintained traditional wedding hall in Basavanagudi. Highly recommended for family events!",
    name: "A Local Resident",
    role: "Family wedding host",
  },
  {
    quote:
      "Beautiful traditional venue with warm hospitality. The dining hall comfortably seated all our guests for a sit-down meal — and the bridal room made the day stress-free.",
    name: "Mrs. Kamala R.",
    role: "Mother of the bride",
  },
  {
    quote:
      "We performed our son's Upanayana here. The space carries an auspicious, calm energy — exactly what such a sacred ceremony deserves.",
    name: "Mr. Sridhar Iyer",
    role: "Thread ceremony",
  },
];

export const EVENT_TYPE_OPTIONS = [
  "Wedding / Reception",
  "Engagement",
  "Sacred Thread Ceremony (Upanayana)",
  "Baby Shower / Naming Ceremony",
  "Puja / Bhajan",
  "Cultural Gathering",
  "Other",
];
